<template>
  <el-dialog class="restart-private"
             :visible.sync="show"
             :title="$t('privateNetInstance.openTitle')"
             :close-on-click-modal="false"
             :before-close="handleClose">
    <p>{{ $t('privateNetInstance.openTip', [name]) }}</p>
    <div slot="footer" class="dialog-footer">
      <el-button @click="cancelRestart">{{ $t('privateNetInstance.cancel') }}</el-button>
      <el-button @click="sureRestart" type="primary">{{ $t('privateNetInstance.sure') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    name: "Restart",
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      instanceId: {
        type: String,
        default: ''
      },
      name: {
        type: String,
        default: ''
      },
      region: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        show: false
      }
    },
    methods: {
      handleClose() {
        this.show = false;
        this.$emit('update:visible', false);
      },
      cancelRestart() {
        this.handleClose();
      },
      sureRestart() {
        this.restartInstance();
      },
      restartInstance() {
        const params = {
          instanceId: this.instanceId,
          region: this.region,
          clientToken: Normal.getClientToken(),
        };
        Ajax.put('/api/cps/restartInstance', params)
          .then()
          .catch()
          .finally(() => {
            this.handleClose();
            this.$emit('refresh')
          });
      }
    },
    watch: {
      visible(newVal) {
        this.show = newVal;
      }
    }
  }
</script>

<style lang="scss">
  .restart-private{

  }
</style>




// WEBPACK FOOTER //
// src/components/privateNetInstance/operates/Restart.vue